module.exports = __webpack_public_path__ + "static/media/clue--mockup.4dfc7e98.png";